export class PaginationResult<T> {
  public listOfResult: T;
  public size: number;
  public totalPage: number;

  constructor() {
    this.listOfResult = <T>{};
    this.size = 0;
    this.totalPage = 0;
  }
}
